/**
 * @file automatically generated from MApp.Spatial.Ogc.ExpressionType
 */

export enum ExpressionType {
    PropertyName = 0,
    Literal = 1,
    LowerBoundary = 2,
    UpperBoundary = 3,
    Add = 4,
    Subtract = 5,
    Multiply = 6,
    Divide = 7,
    Function = 8
}
